import moment from 'moment';
import { dateString } from 'researcher/helpers/date';
export var formatForLocale = function formatForLocale(date, t) {
  return dateString(t, moment(date), 'curie.date-format');
};
export var formatAsTimeAgo = function formatAsTimeAgo(date, t) {
  var dateMoment = moment(date);
  var now = moment();
  var hoursDiff = now.diff(dateMoment, 'hours', true);
  if (hoursDiff > 24) {
    return formatForLocale(date, t);
  }
  var minutesDiff = now.diff(dateMoment, 'minutes', true);
  if (minutesDiff >= 60) {
    // only need the integer part of the hour difference here
    hoursDiff = now.diff(dateMoment, 'hours');
    return t("%s hour".concat(hoursDiff > 1 ? 's' : '', " ago"), hoursDiff);
  }
  if (minutesDiff < 2) {
    return t('about a minute ago');
  }

  // only need the integer part of the minute difference here
  minutesDiff = now.diff(dateMoment, 'minutes');
  return t('%s minutes ago', minutesDiff);
};